import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { DATE_TIME_FORMAT } from '../../constants';

const OrdersList = ({ orders, showHeader = true, loading }) => {
  const tdStyle = { verticalAlign: 'middle' };

  return (
    <React.Fragment>
      <br />
      {showHeader && <h4>Purchase Orders</h4>}
      <table className="table">
        <thead>
          <tr>
            <th>Link</th>
            <th>Order</th>
            <th>Purchase</th>
            <th>User</th>
            <th>Status</th>
            <th>Charge</th>
            <th>Purchase date</th>
            <th>Payment date</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => {
            const orderLinesLength = order.order_lines.length || 1;

            return (
              <React.Fragment key={order.id}>
                <tr>
                  <td style={tdStyle} rowSpan={orderLinesLength}>
                    <Link to={`/orders/${order.id}`}>View</Link>
                  </td>
                  <td style={tdStyle} rowSpan={orderLinesLength}>
                    {order.id}
                  </td>
                  <td style={tdStyle} rowSpan={orderLinesLength}>
                    {order.purchase.id}
                  </td>
                  <td style={tdStyle} rowSpan={orderLinesLength}>
                    {order.user_profile}
                  </td>
                  <td style={tdStyle} rowSpan={orderLinesLength}>
                    {order.purchase.status}
                  </td>
                  <td style={tdStyle} rowSpan={orderLinesLength}>
                    {order.purchase.charge_type}
                  </td>
                  <td style={tdStyle} rowSpan={orderLinesLength}>
                    {order.purchase.purchase_date
                      ? moment(order.purchase.purchase_date).format(
                          DATE_TIME_FORMAT,
                        )
                      : ''}
                  </td>
                  <td style={tdStyle} rowSpan={orderLinesLength}>
                    {order.purchase.payment_date
                      ? moment(order.purchase.payment_date).format(
                          DATE_TIME_FORMAT,
                        )
                      : ''}
                  </td>
                  {order.order_lines.length ? (
                    <td style={tdStyle}>{order.order_lines[0].description}</td>
                  ) : (
                    <td></td>
                  )}
                </tr>
                {orderLinesLength > 1 &&
                  order.order_lines.map((orderLine, index) => {
                    if (index === 0) return null;
                    return (
                      <tr key={index}>
                        <td style={tdStyle}>{orderLine.description}</td>
                      </tr>
                    );
                  })}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      {!loading && !Boolean(orders.length) && <span>No Results</span>}
    </React.Fragment>
  );
};

export default OrdersList;
